const situations = [
  'ультиматумы и требования «или так, или никак»;',
  'прямое давление и эскалация;',
  'эмоциональные реакции собеседника;',
  'манипуляции и скрытое влияние;',
  'попытки перевести разговор на личности;',
  'обвинения в адрес руководителя;',
  'провокации, выводящие из равновесия;',
  'попытка навязать готовое решение;',
  'ограничение времени для принятия решения.',
];

const algorithm = [
  'остановиться',
  'вернуть разговор к фактам',
  'уточнить интересы',
  'обозначить позицию',
  'определить границы',
  'предложить варианты',
  'зафиксировать договорённость',
];

export default function UnderPressure() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как руководителю вести переговоры под давлением
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сложные ситуации, в которых важно сохранять контроль над собой и над разговором
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-flashlight-line text-amber-500 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-600 rounded-2xl p-6 md:p-10">
          <p className="text-teal-100 text-xs uppercase tracking-wider text-center mb-5">Алгоритм действий</p>
          <div className="flex flex-wrap justify-center items-center gap-2">
            {algorithm.map((step, i) => (
              <div key={step} className="flex items-center gap-2">
                <span className="bg-white/15 border border-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  {step}
                </span>
                {i < algorithm.length - 1 && (
                  <i className="ri-arrow-right-line text-teal-100"></i>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}